module.exports = __webpack_public_path__ + "img/统计椭圆形.bdde18ec.png";